/** Service Icons */
import { ServiceIcons } from './ServiceIcons';
import RoleAzure from '../../assets/icons/azure-role.svg';
import RoleAzureCustom from '../../assets/icons/role-custom.svg';
import RoleGcpCustom from '../../assets/icons/gcp-custom.svg';
import RoleGcp from '../../assets/icons/role-gcp.svg';
import RoleAws from '../../assets/icons/approle_aws.svg';
import RoleAwsCustom from '../../assets/icons/approle_aws_custom.svg';
/** AWS ICONS Imports */
import User from '../../assets/icons/resource-types/User.png';
import ServiceAccount from '../../assets/icons/resource-types/ServiceAccount.svg';
import UserGroups from '../../assets/icons/resource-types/UserGroups.svg';
import Policy from "../../assets/icons/resource-types/Policy.png";
import Role from "../../assets/icons/resource-types/Role.png";
import AWSCompute from "../../assets/icons/resource-types/Compute.png";
import AWSUser from "../../assets/icons/resource-types/users.png";
import EC2Instance from '../../assets/icons/resource-types/aws/resource/Res_Amazon-EC2_Instance_48_Light.svg';
import ElasticIP from '../../assets/icons/resource-types/aws/resource/Res_Amazon-EC2_Elastic-IP-Address_48_Light.svg';
import EBSVolume from '../../assets/icons/resource-types/aws/resource/Res_Amazon-Elastic-Block-Store_Volume_48_Light.svg';
import ImageBuilder from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-EC2-Image-Builder_48.svg';
import SecurityGroup from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-EC2_64.svg';
import KMS from '../../assets/icons/resource-types/aws/resource/Arch_AWS-Key-Management-Service_48.svg';
import S3 from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Simple-Storage-Service_32.svg';
import VPC from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Virtual-Private-Cloud_32.svg';
import NewReleases from '../../assets/icons/resource-types/aws/resource/AWS_Simple_Icons_AWS_Cloud.svg';
import EKS from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Elastic-Kubernetes-Service_32.svg';
import ECR from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Elastic-Container-Registry_32.svg';
import ECS from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Elastic-Container-Service_32.svg';
import Lambda from '../../assets/icons/resource-types/aws/resource/Arch_AWS-Lambda_32.svg';
import RDS from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-RDS_32.svg';
import SecretsManager from '../../assets/icons/resource-types/aws/resource/Arch_AWS-Secrets-Manager_32.svg';
import MSK from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Managed-Streaming-for-Apache-Kafka_32.svg';
import Analytics from '../../assets/icons/resource-types/aws/resource/Arch-Category_Analytics_32.svg';
import ApplicationIntegration from '../../assets/icons/resource-types/aws/resource/Arch-Category_Application-Integration_32.svg';
import Blockchain from '../../assets/icons/resource-types/aws/resource/Arch-Category_Blockchain_32.svg';
import BusinessApplications from '../../assets/icons/resource-types/aws/resource/Arch-Category_Business-Applications_32.svg';
import FinancialManagement from '../../assets/icons/resource-types/aws/resource/Arch-Category_Cloud-Financial-Management_32.svg';
import Containers from '../../assets/icons/resource-types/aws/resource/Arch-Category_Containers_32.svg';
import CustomerEnablement from '../../assets/icons/resource-types/aws/resource/Arch-Category_Customer-Enablement_32.svg';
import DeveloperTools from '../../assets/icons/resource-types/aws/resource/Arch-Category_Developer-Tools_32.svg';
import EndUserComputing from '../../assets/icons/resource-types/aws/resource/Arch-Category_End-User-Computing_32.svg';
import FrontEndWebMobile from '../../assets/icons/resource-types/aws/resource/Arch-Category_Front-End-Web-Mobile_32.svg';
import Games from '../../assets/icons/resource-types/aws/resource/Arch-Category_Games_32.svg';
import MachineLearning from '../../assets/icons/resource-types/aws/resource/Arch-Category_Machine-Learning_32.svg';
import ManagementGovernance from '../../assets/icons/resource-types/aws/resource/Arch-Category_Management-Governance_32.svg';
import MediaServices from '../../assets/icons/resource-types/aws/resource/Arch-Category_Media-Services_32.svg';
import MigrationTransfer from '../../assets/icons/resource-types/aws/resource/Arch-Category_Migration-Transfer_32.svg';
import NetworkingContentDelivery from '../../assets/icons/resource-types/aws/resource/Arch-Category_Networking-Content-Delivery_32.svg';
import QuantumTechonologies from '../../assets/icons/resource-types/aws/resource/Arch-Category_Quantum-Technologies_32.svg';
import Robotics from '../../assets/icons/resource-types/aws/resource/Arch-Category_Robotics_32.svg';
import Satellite from '../../assets/icons/resource-types/aws/resource/Arch-Category_Satellite_32.svg';
import SecurityIdentityComplicance from '../../assets/icons/resource-types/aws/resource/Arch-Category_Security-Identity-Compliance_32.svg';
import Serverless from '../../assets/icons/resource-types/aws/resource/Arch-Category_Serverless_32.svg';
import Storage from '../../assets/icons/resource-types/aws/resource/Arch-Category_Storage_32.svg';
import VirtualReality from '../../assets/icons/resource-types/aws/resource/Arch-Category_VR-AR_32.svg';
/** AWS Sub-category Icons : ANALYTICS */
import Athena from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Athena_32.svg';
import CloudSearch from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-CloudSearch_32.svg';
import DataZone from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-DataZone_32.svg';
import EMR from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-EMR_32.svg';
import FinSpace from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-FinSpace_32.svg';
import Kinesis from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Kinesis_32.svg';
import KinesisDataAnalytics from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Kinesis-Data-Analytics_32.svg';
import KinesisDataStreams from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Kinesis-Data-Streams_32.svg';
import KinesisFirehose from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Kinesis-Firehose_32.svg';
import KinesisVideoStreams from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Kinesis-Video-Streams_32.svg';
import ManagedStreamingApache from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Managed-Streaming-for-Apache-Kafka_32.svg';
import OpenSearchService from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-OpenSearch-Service_32.svg';
import QuickSight from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-QuickSight_32.svg';
import Redshift from '../../assets/icons/resource-types/aws/resource/analytics/Arch_Amazon-Redshift_32.svg';
import CleanRooms from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Clean-Rooms_32.svg';
import DataExchange from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Data-Exchange_32.svg';
import DataPipeline from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Data-Pipeline_32.svg';
import Glue from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Glue_32.svg';
import GlueDataBrew from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Glue-DataBrew_32.svg';
import GlueElasticViews from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Glue-Elastic-Views_32.svg';
import LakeFormation from '../../assets/icons/resource-types/aws/resource/analytics/Arch_AWS-Lake-Formation_32.svg';
/** AWS Sub-category Icons : APP INTEGRATION */
import APIGateway from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_ Amazon-API-Gateway_32.svg';
import AppFlow from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_Amazon-AppFlow_32.svg';
import EventBridge from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_Amazon-EventBridge_32.svg';
import ManagedWorkflowsApache from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_Amazon-Managed-Workflows-for-Apache-Airflow_32.svg';
import MQ from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_Amazon-MQ_32.svg';
import SimpleNotificationService from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_Amazon-Simple-Notification-Service_32.svg';
import SimpleQueueService from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_Amazon-Simple-Queue-Service_32.svg';
import AppSync from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_AWS-AppSync_32.svg';
import ConsoleMobileApplication from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_AWS-Console-Mobile-Application _32.svg';
import ExpressWorkflows from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_AWS-Express-Workflows_32.svg';
import StepFunctions from '../../assets/icons/resource-types/aws/resource/app_integration/Arch_AWS-Step-Functions_32.svg';
import Slack from '../../assets/icons/Slack@2x.svg';
/** AWS Sub-category Icons : BLOCKCHAIN */
import ManagedBlockchain from '../../assets/icons/resource-types/aws/resource/blockchain/Arch_Amazon-Managed-Blockchain_32.svg';
import QuantumLedgerDatabase from '../../assets/icons/resource-types/aws/resource/blockchain/Arch_Amazon-Quantum-Ledger-Database_32.svg';
/** AWS Sub-category Icons : BUSINESS APPLICATIONS */
import AlexaForBusiness from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Alexa-For-Business_32.svg';
import Chime from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Chime_32.svg';
import ChimeSDK from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Chime-SDK_32.svg';
import ChimeVoiceConnector from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Chime-Voice-Connector_32.svg';
import Connect from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Connect_32.svg';
import Honeycode from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Honeycode_32.svg';
import Pinpoint from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Pinpoint_32.svg';
import PinpointAPI from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Pinpoint-APIs_32.svg';
import SimpleEmailService from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-Simple-Email-Service_32.svg';
import WorkDocs from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-WorkDocs_32.svg';
import WorkDocsSDK from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-WorkDocs-SDK_32.svg';
import WorkMail from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_Amazon-WorkMail_32.svg';
import SupplyChain from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_AWS-Supply-Chain_32.svg';
import Wickr from '../../assets/icons/resource-types/aws/resource/business-applications/Arch_AWS-Wickr_32.svg';
/** AWS Sub-category : CLOUD FINANCIAL MANAGEMENT */
import ApplicationCostProfiler from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_AWS-Application-Cost-Profiler_32.svg';
import BillingConductor from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_AWS-Billing-Conductor_32.svg';
import Budgets from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_AWS-Budgets_32.svg';
import CostUsageReport from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_AWS-Cost-and-Usage-Report_32.svg';
import CostExplorer from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_AWS-Cost-Explorer_32.svg';
import ReservedInstanceReporting from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_Reserved-Instance-Reporting_32.svg';
import SavingsPlans from '../../assets/icons/resource-types/aws/resource/cloud-financial-management/Arch_Savings-Plans_32.svg';
/** AWS Sub-category : COMPUTE */
import EC2 from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-EC2_32.svg';
import AutoScaling from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-EC2-Auto-Scaling_32.svg';
import M5n from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-EC2-M5n_32.svg';
import R5n from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-EC2-R5n_32.svg';
import ElasticContainerKubernetes from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-Elastic-Container-Kubernetes_32.svg';
import ElasticContainerRegistry from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-Elastic-Container-Registry_32.svg';
import ElasticContainerService from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-Elastic-Container-Service_32.svg';
import Genomics from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-Genomics-CLI_32.svg';
import Lightsail from '../../assets/icons/resource-types/aws/resource/compute/Arch_Amazon-Lightsail_32.svg';
import AppRunner from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-App-Runner_32.svg';
import Batch from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Batch_32.svg';
import ComputeOptimizer from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Compute-Optimizer_32.svg';
import ElasticBeanstalk from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Elastic-Beanstalk_32.svg';
import Fargate from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Fargate_32.svg';
import LocalZones from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Local-Zones_32.svg';
import NitroEnclaves from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Nitro-Enclaves_32.svg';
import OutpostsFamily from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Outposts-family_32.svg';
import OutpostsRack from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Outposts-rack_32.svg';
import OutpostsServers from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Outposts-servers_32.svg';
import ParallelCluster from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-ParallelCluster_32.svg';
import ServerlessApplicationRepository from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Serverless-Application-Repository_32.svg';
import SimSpaceWeaver from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-SimSpace-Weaver_32.svg';
import ThinkboxDeadline from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Thinkbox-Deadline_32.svg';
import ThinkboxFrost from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Thinkbox-Frost_32.svg';
import ThinkboxKrakatoa from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Thinkbox-Krakatoa_32.svg';
import ThinkboxSequoia from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Thinkbox-Sequoia_32.svg';
import ThinkboxStoke from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Thinkbox-Stoke_32.svg';
import ThinkboxXMesh from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Thinkbox-XMesh_32.svg';
import Wavelength from '../../assets/icons/resource-types/aws/resource/compute/Arch_AWS-Wavelength_32.svg';
import Bottlerocket from '../../assets/icons/resource-types/aws/resource/compute/Arch_Bottlerocket_32.svg';
import ElasticFabricAdapter from '../../assets/icons/resource-types/aws/resource/compute/Arch_Elastic-Fabric-Adapter_32.svg';
import NICE_DCV from '../../assets/icons/resource-types/aws/resource/compute/Arch_NICE-DCV_32.svg';
import NICEEnginFrame from '../../assets/icons/resource-types/aws/resource/compute/Arch_NICE-EnginFrame_32.svg';
import VMWareCloudOnAWS from '../../assets/icons/resource-types/aws/resource/compute/Arch_VMware-Cloud-on-AWS_32.svg';
/** AWS UNSORTED */
import awsDynamoDb from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-DynamoDB_32.svg'; //
import awsElastiCache from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-ElastiCache_32.svg';
import awsNeptune from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Neptune_32.svg';
import awsCloudFormation from '../../assets/icons/resource-types/aws/resource/Arch_AWS-CloudFormation_32.svg'; //
import awsChild from '../../assets/icons/202308/AWS Child@2x.svg';
import awsOrg from '../../assets/icons/202308/AWS Org@2x.svg';
import awsApiGateway from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-API-Gateway_64.svg';
import awsAthena from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Athena_16.svg';
import awsChime from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Chime_16.svg';
import awsCloudFront from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-CloudFront_16.svg';
import awsCloudWatch from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-CloudWatch_16.svg';
import awsCognito from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Cognito_16.svg';
import awsGuardDuty from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-GuardDuty_16.svg';
import awsKinesis from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Kinesis_16.svg';
import awsLightsail from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Lightsail_16.svg';
import awsRedshift from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Redshift_16.svg';
import awsRoute53 from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Route-53_16.svg';
import awsSns from '../../assets/icons/resource-types/aws/resource/Arch_Amazon-Simple-Notification-Service_16.svg';
import awsAmplify from '../../assets/icons/resource-types/aws/resource/Arch_AWS-Amplify_16.svg';
import awsGlue from '../../assets/icons/resource-types/aws/resource/Arch_AWS-Glue_16.svg';
import awsIot from '../../assets/icons/resource-types/aws/resource/Arch_AWS-IoT-Core_16.svg';
import awsEcsService from '../../assets/icons/resource-types/aws/resource/Res_Amazon-Elastic-Container-Service_Service_48_Light.svg';
import awsEcsTask from '../../assets/icons/resource-types/aws/resource/Res_Amazon-Elastic-Container-Service_Task_48_Light.svg';
/** GCP Icons */
import BigQuery from '../../assets/icons/resource-types/gcp/bigquery.svg';
import BigTable from '../../assets/icons/resource-types/gcp/bigtable.svg';
import CloudFunctions from '../../assets/icons/resource-types/gcp/cloud_functions.svg';
import CloudStorage from '../../assets/icons/resource-types/gcp/cloud_storage.svg';
import ComputeEngine from '../../assets/icons/resource-types/gcp/compute_engine.svg';
import Project from '../../assets/icons/resource-types/gcp/project.svg';
import PubSub from '../../assets/icons/resource-types/gcp/pubsub.svg';
import GKECluster from '../../assets/icons/resource-types/gcp/gke_on-prem.svg';
import SQLInstance from '../../assets/icons/resource-types/gcp/cloud_sql.svg';
import Kubernetes from '../../assets/icons/resource-types/gcp/google_kubernetes_engine.svg';
import GcpGoogleFolder from '../../assets/icons/202308/Google Folder@2x.svg';
import GcpOrg from '../../assets/icons/202308/Google Org@2x.svg';
import GcpProject from '../../assets/icons/202308/Google Project@2x.svg';
import GcpProjectMono from '../../assets/icons/202308/GCP project@2x.svg';
import GcpProjectSolid from '../../assets/icons/202308/GCP project solid@2x.svg';
import GcpDatabase from '../../assets/icons/202308/Database.svg';
import GcpRole from '../../assets/icons/202308/Role.svg';
import GcpIamServiceAccountKey from '../../assets/icons/IAM Service Key.svg';
import GcpAlloyDb from '../../assets/icons/AlloyDB.svg';
/** Azure Icons */
import AzureProviderMetadataType from '../../assets/icons/resource-types/azure/00025-icon-service-Service-Providers.svg';
import AzureSQLServerType from '../../assets/icons/resource-types/azure/01850-icon-service-Arc-SQL-Server.svg';
import AzureTenantType from '../../assets/icons/resource-types/azure/02679-icon-service-Tenant-Properties.svg';
import AzureSubscriptionType from '../../assets/icons/resource-types/azure/10002-icon-service-Subscriptions.svg';
import AzureResourceGroupType from '../../assets/icons/resource-types/azure/10007-icon-service-Resource-Groups.svg';
import AzureVMType from '../../assets/icons/resource-types/azure/10021-icon-service-Virtual-Machine.svg';
import AzureSQLServerDatabaseType from '../../assets/icons/resource-types/azure/10132-icon-service-SQL-Server.svg';
import AzureSQLInstancePoolType from '../../assets/icons/resource-types/azure/10139-icon-service-Instance-Pools.svg';
import AzureRoleDefinitionType from '../../assets/icons/resource-types/azure/10340-icon-service-Azure-AD-Roles-and-Administrators.svg';
import AzureKubernetes from '../../assets/icons/resource-types/azure/10023-icon-service-Kubernetes-Services.svg';
import AzureResourceGroup from '../../assets/icons/202308/Resource Group@2x.svg';
import AzureResourceGroupMono from '../../assets/icons/202308/Azure resource group@2x.svg';
import AzureSuscription from '../../assets/icons/202308/Subscription@2x.svg';
import AzureServer from '../../assets/icons/202308/Server.svg';
import AzureVirtualMachine from '../../assets/icons/resource-types/azure/Vitual-Machine@2x.svg';
import AzureCosmosDbAccount from '../../assets/icons/resource-types/azure/10121-icon-service-Azure-Cosmos-DB.svg';
import AzureStorage from '../../assets/icons/resource-types/azure/storage.svg';
import AzureStorageTable from '../../assets/icons/resource-types/azure/02909-icon-service-Storage-Tasks.svg';
import AzureManagedCluster from '../../assets/icons/resource-types/azure/10127-icon-service-Virtual-Clusters.svg';
import AzureLoadBalancer from '../../assets/icons/resource-types/azure/02302-icon-service-Load-Balancer-Hub.svg';
import AzureLogicAppWorkflow from '../../assets/icons/resource-types/azure/02631-icon-service-Logic-Apps.svg';
import AzureWebApps from '../../assets/icons/resource-types/azure/02515-icon-service-Web-App-+-Database.svg';
import AzureBlobContainer from '../../assets/icons/resource-types/azure/10781-icon-service-Blob-Page.svg';
import AzureBlobService from '../../assets/icons/resource-types/azure/10780-icon-service-Blob-Block.svg';
import AzureRedisCaches from '../../assets/icons/resource-types/azure/10137-icon-service-Cache-Redis.svg';
import AzureDevOps from '../../assets/icons/resource-types/azure/10261-icon-service-Azure-DevOps.svg';
import AzurePipelines from '../../assets/icons/resource-types/azure/azurepipelines.svg';
import AzureBlobStorage from '../../assets/icons/resource-types/azure/storage-blob.svg';
import AzureCosmosDb from '../../assets/icons/resource-types/azure/10121-icon-service-Azure-Cosmos-DB.svg';
import AzureLogicApps from '../../assets/icons/resource-types/azure/02631-icon-service-Logic-Apps.svg';
import AzureDataFactories from '../../assets/icons/resource-types/azure/10126-icon-service-Data-Factories.svg';
import AzureCdnProfiles from '../../assets/icons/resource-types/azure/00056-icon-service-CDN-Profiles.svg';
import AzureCacheRedis from '../../assets/icons/resource-types/azure/10137-icon-service-Cache-Redis.svg';
import AzureAppServices from '../../assets/icons/resource-types/azure/10035-icon-service-App-Services.svg';
import AzureFiles from '../../assets/icons/resource-types/azure/storage-files.svg';
import AzureArchiveStorage from '../../assets/icons/resource-types/azure/storage-files.svg';
import AzureDatalakeStorage from '../../assets/icons/resource-types/azure/10090-icon-service-Data-Lake-Storage-Gen1.svg';
import AzureContainerRegistries from '../../assets/icons/resource-types/azure/10105-icon-service-Container-Registries.svg';
import AzureMonitor from '../../assets/icons/resource-types/azure/00001-icon-service-Monitor.svg';
import AzureKeyVaults from '../../assets/icons/resource-types/azure/10245-icon-service-Key-Vaults.svg';
/** Applications */
import AwsApplication from '../../assets/icons/type-aws.svg';
import AzureApplication from '../../assets/icons/type-azure.svg';
import DropboxApplication from '../../assets/icons/type-dropbox.svg';
import GoogleApplication from '../../assets/icons/type-google.svg';
import NginxApplication from '../../assets/icons/type-nginx.svg';
import GenericApplication from '../../assets/icons/type-generic.svg';
import HttpsApplication from '../../assets/icons/HTTPS-app.svg';
import SamlApplication from '../../assets/icons/SAML-app.svg';
import GithubRepositoriesMono from '../../assets/icons/202308/repositories@2x.svg';
import GithubApplication from '../../assets/icons/Github@2x.svg';
import Oidc from '../../assets/icons/OIDC.svg';
import Okta from '../../assets/icons/Okta.svg';
import Entra from '../../assets/icons/Entra.svg';
import Auth0 from '../../assets/icons/Auth0.svg';
import OneLogin from '../../assets/icons/OneLogin.svg';
import Ping from '../../assets/icons/PingID.svg';
import iconWorkload from '../../assets/icons/Workflow.svg';
import KubernetesDeployment from '../../assets/icons/KubernetesDeployment.svg';
import KubernetesPod from '../../assets/icons/KubernetesPod.svg';
import KubernetesStatefullSet from '../../assets/icons/KubernetesStatefullset.svg';
import KubernetesServices from '../../assets/icons/KubernetesServices.svg';
import Salesforce from '../../assets/icons/Salesforce.svg';
import Gcp from '../../assets/icons/GCP.svg';
import Aws from '../../assets/icons/AWS.svg';
import Azure from '../../assets/icons/Azure.svg';
import AdDomainController from '../../assets/icons/ad-domain-controller.svg';
// Service Icons
/** AWS ICONS Imports */
import TrustedRelations from '../../assets/icons/Trusted Relation@2x.svg';
import RdpServer from '../../assets/icons/Remote-control@2x.svg';
import ApacheKafka from '../../assets/icons/Apache-Kafka@2x.svg';
import ServiceNow from '../../assets/icons/Service Now@2x.svg';
import Jira from '../../assets/icons/Jira@2x.svg';
// Bundle Icons
import BundleAws from '../../assets/icons/BUNDLE_AWS.svg';
import BundleGcp from '../../assets/icons/BUNDLE_GCP.svg';
import BundleAzure from '../../assets/icons/BUNDLE_AZURE.svg';
export var ResourceIcons = [
    User,
    Policy,
    Role,
    AWSCompute,
    AWSUser,
    ElasticIP, //6
];
export var DisplayTypeToIconMap = {
    BUNDLE_AWS: BundleAws,
    BUNDLE_GCP: BundleGcp,
    BUNDLE_AZURE: BundleAzure,
    AWS_ECS_SERVICE: awsEcsService,
    AWS_ECS_TASK: awsEcsTask,
    AD_DOMAIN_CONTROLER: AdDomainController,
    AZURE_DEVOPS: AzureDevOps,
    AZURE_PIPELINES: AzurePipelines,
    AZURE_BLOBSTORAGE: AzureBlobStorage,
    AZURE_COSMOSDB: AzureCosmosDb,
    AZURE_LOGIC_APPS: AzureLogicApps,
    AZURE_DATA_FACTORIES: AzureDataFactories,
    AZURE_CDN_PROFILES: AzureCdnProfiles,
    AZURE_CACHE_REDIS: AzureCacheRedis,
    AZURE_APP_SERVICES: AzureAppServices,
    AZURE_FILES: AzureFiles,
    AZURE_ARCHIVE_STORAGE: AzureArchiveStorage,
    AZURE_DATALAKE_STORAGE: AzureDatalakeStorage,
    AZURE_CONTAINER_REGISTRIES: AzureContainerRegistries,
    AZURE_MONITOR: AzureMonitor,
    AZURE_KEY_VAULTS: AzureKeyVaults,
    AZURE: Azure,
    AWS: Aws,
    GCP: Gcp,
    SALESFORCE: Salesforce,
    KUBE_SERVICES: KubernetesServices,
    AWS_DYNAMODB: awsDynamoDb,
    AWS_CLOUDFORMATION: awsCloudFormation,
    AWS_API_GATEWAY: awsApiGateway,
    AWS_CHIME: awsChime,
    AWS_ATHENA: awsAthena,
    AWS_CLOUDFRONT: awsCloudFront,
    AWS_CLOUDWATCH: awsCloudWatch,
    AWS_COGNITO: awsCognito,
    AWS_GUARD_DUTY: awsGuardDuty,
    AWS_KINESIS: awsKinesis,
    AWS_LIGHTSAIL: awsLightsail,
    AWS_REDSHIFT: awsRedshift,
    AWS_ROUTE53: awsRoute53,
    AWS_SNS: awsSns,
    AWS_AMPLIFY: awsAmplify,
    AWS_GLUE: awsGlue,
    AWS_IOT: awsIot,
    GCP_ALLOYDB: GcpAlloyDb,
    KUBE_STATEFULLSET: KubernetesStatefullSet,
    KUBE_POD: KubernetesPod,
    KUBE_DEPLOYMENT: KubernetesDeployment,
    KUBE_NAMESPACES: ServiceIcons.KUBE_NAMESPACES,
    KUBE_CLUSTERS: ServiceIcons.KUBE_CLUSTERS,
    APPROLE_AWS: RoleAws,
    APPROLE_AWS_CUSTOM: RoleAwsCustom,
    APPROLE_AZURE: RoleAzure,
    APPROLE_AZURE_CUSTOM: RoleAzureCustom,
    APPROLE_GCP: RoleGcp,
    APPROLE_GCP_CUSTOM: RoleGcpCustom,
    SLACK: Slack,
    RDP_SERVER: RdpServer,
    APACHE_KAFKA: ApacheKafka,
    GCP_IAM_SERVICE_ACCOUNT_KEY: GcpIamServiceAccountKey,
    WORKLOAD: iconWorkload,
    AZURE_STORAGE_TABLE: AzureStorageTable,
    AZURE_MANAGED_CLUSTER: AzureManagedCluster,
    AZURE_LOAD_BALANCER: AzureLoadBalancer,
    AZURE_LOGIC_APP_WORKFLOW: AzureLogicAppWorkflow,
    AZURE_WEB_APPS: AzureWebApps,
    AZURE_BLOB_CONTAINER: AzureBlobContainer,
    AZURE_BLOB_SERVICE: AzureBlobService,
    AZURE_REDIS_CACHES: AzureRedisCaches,
    AZURE_STORAGE: AzureStorage,
    AZURE_COSMOS_DB_ACCOUNT: AzureCosmosDbAccount,
    AZURE_VIRTUAL_MACHINE: AzureVirtualMachine,
    GITHUB_APPLICATION: GithubApplication,
    USERGROUPS: UserGroups,
    SERVICEACCOUNT: ServiceAccount,
    USER: User,
    POLICY: Policy,
    ROLE: Role,
    SERVER: ServiceIcons.SERVER,
    SERVER_PRIVATE: ServiceIcons.SERVER_PRIVATE,
    DATABASE: ServiceIcons.DATABASE,
    APPROLE: ServiceIcons.APPROLE,
    APPROLE_DYNAMIC: ServiceIcons.APPROLE_DYNAMIC,
    ACCESS_KEY: ServiceIcons.ACCESS_KEY,
    FEDERATED_USER: ServiceIcons.FEDERATED_USER,
    TRUSTED_RELATION: ServiceIcons.TRUSTED_RELATIONS,
    AWS_EC2_Instance: EC2Instance,
    AWS_Compute: AWSCompute,
    AWS_User: AWSUser,
    AWS_EC2_Elastic_IP: ElasticIP,
    AWS_EC2_EBS_Volume: EBSVolume,
    AWS_EC2_Image: ImageBuilder,
    AWS_EC2_Key_Pair: EC2Instance,
    AWS_EC2_Network_Interface: EC2Instance,
    AWS_EC2_Security_Group: SecurityGroup,
    AWS_KMS: KMS,
    AWS_S3: S3,
    AWS_VPC: VPC,
    All_Resource: NewReleases,
    AWS_EKS: EKS,
    AWS_ECR: ECR,
    AWS_ECS: ECS,
    AWS_ECS_Container: ECS,
    AWS_LAMBDA: Lambda,
    AWS_EC2_Load_Balancer: EC2Instance,
    AWS_EC2_Target_Group: EC2Instance,
    AWS_EC2_EBS_Snapshot: EC2Instance,
    AWS_EC2_Placement_Group: EC2Instance,
    AWS_RDS_Cluster: RDS,
    AWS_RDS_DB: RDS,
    AWS_SM: SecretsManager,
    AWS_MSK: MSK,
    AWS_ANALYTICS: Analytics,
    AWS_APPLICATION_INTEGRATION: ApplicationIntegration,
    AWS_BLOCKCHAIN: Blockchain,
    AWS_BUSINESS_APPLICATIONS: BusinessApplications,
    AWS_CFM: FinancialManagement,
    AWS_CONTAINERS: Containers,
    AWS_CUSTOMER_ENABLEMENT: CustomerEnablement,
    AWS_DATABASE: RDS,
    AWS_DEVELOPER_TOOLS: DeveloperTools,
    AWS_EUC: EndUserComputing,
    AWS_FEW: FrontEndWebMobile,
    AWS_GAMES: Games,
    AWS_MACHINE_LEARNING: MachineLearning,
    AWS_MANAGEMENT_GOVERNANCE: ManagementGovernance,
    AWS_MEDIA_SERVICES: MediaServices,
    AWS_MIGRATION_TRANSFER: MigrationTransfer,
    AWS_NCD: NetworkingContentDelivery,
    AWS_QUANTUM_TECHNOLOGIES: QuantumTechonologies,
    AWS_ROBOTICS: Robotics,
    AWS_SATELLITE: Satellite,
    AWS_SIC: SecurityIdentityComplicance,
    AWS_SERVERLESS: Serverless,
    AWS_STORAGE: Storage,
    AWS_VR_AR: VirtualReality,
    AWS_ANALYTICS_ATHENA: Athena,
    AWS_ANALYTICS_CLOUDSEARCH: CloudSearch,
    AWS_ANALYTICS_DATAZONE: DataZone,
    AWS_ANALYTICS_EMR: EMR,
    AWS_ANALYTICS_FINSPACE: FinSpace,
    AWS_ANALYTICS_KINESIS: Kinesis,
    AWS_ANALYTICS_KDA: KinesisDataAnalytics,
    AWS_ANALYTICS_KDS: KinesisDataStreams,
    AWS_ANALYTICS_KF: KinesisFirehose,
    AWS_ANALYTICS_KVS: KinesisVideoStreams,
    AWS_ANALYTICS_MSA: ManagedStreamingApache,
    AWS_ANALYTICS_OSS: OpenSearchService,
    AWS_ANALYTICS_QUICKSIGHT: QuickSight,
    AWS_ANALYTICS_REDSHIFT: Redshift,
    AWS_ANALYTICS_CLEANROOMS: CleanRooms,
    AWS_ANALYTICS_DATAEXCHANGE: DataExchange,
    AWS_ANALYTICS_DATAPIPELINE: DataPipeline,
    AWS_ANALYTICS_GLUE: Glue,
    AWS_ANALYTICS_GDB: GlueDataBrew,
    AWS_ANALYTICS_GEV: GlueElasticViews,
    AWS_ANALYTICS_LAKEFORMATION: LakeFormation,
    AWS_APPINTEGRATION_API_GATEWAY: APIGateway,
    AWS_APPINTEGRATION_APPFLOW: AppFlow,
    AWS_APPINTEGRATION_EVENTBRIDGE: EventBridge,
    AWS_APPINTEGRATION_MANAGEDWORKFLOWSAPACHE: ManagedWorkflowsApache,
    AWS_APPINTEGRATION_MQ: MQ,
    AWS_APPINTEGRATION_SNS: SimpleNotificationService,
    AWS_APPINTEGRATION_SQS: SimpleQueueService,
    AWS_APPINTEGRATION_APPSYNC: AppSync,
    AWS_APPINTEGRATION_CMA: ConsoleMobileApplication,
    AWS_APPINTEGRATION_EXPRESSWORKFLOWS: ExpressWorkflows,
    AWS_APPINTEGRATION_STEPFUNCTIONS: StepFunctions,
    AWS_BLOCKCHAIN_MANAGEDBLOCKCHAIN: ManagedBlockchain,
    AWS_BLOCKCHAIN_QLD: QuantumLedgerDatabase,
    AWS_BUSINESSAPPLICATIONS_AFB: AlexaForBusiness,
    AWS_BUSINESSAPPLICATIONS_CHIME: Chime,
    AWS_BUSINESSAPPLICATIONS_CHIMESDK: ChimeSDK,
    AWS_BUSINESSAPPLICATIONS_CVC: ChimeVoiceConnector,
    AWS_BUSINESSAPPLICATIONS_CONNECT: Connect,
    AWS_BUSINESSAPPLICATIONS_HONEYCODE: Honeycode,
    AWS_BUSINESSAPPLICATIONS_PINPOINT: Pinpoint,
    AWS_BUSINESSAPPLICATIONS_PINPOINTAPI: PinpointAPI,
    AWS_BUSINESSAPPLICATIONS_SES: SimpleEmailService,
    AWS_BUSINESSAPPLICATIONS_WORKDOCS: WorkDocs,
    AWS_BUSINESSAPPLICATIONS_WORKDOCSSDK: WorkDocsSDK,
    AWS_BUSINESSAPPLICATIONS_WORKMAIL: WorkMail,
    AWS_BUSINESSAPPLICATIONS_SUPPLYCHAIN: SupplyChain,
    AWS_BUSINESSAPPLICATIONS_WICKR: Wickr,
    AWS_CLOUDFINANCIALMANAGEMENT_ACP: ApplicationCostProfiler,
    AWS_CLOUDFINANCIALMANAGEMENT_BILLING_CONDUCTOR: BillingConductor,
    AWS_CLOUDFINANCIALMANAGEMENT_BUDGETS: Budgets,
    AWS_CLOUDFINANCIALMANAGEMENT_CUR: CostUsageReport,
    AWS_CLOUDFINANCIALMANAGEMENT_COSTEXPLORER: CostExplorer,
    AWS_CLOUDFINANCIALMANAGEMENT_RIR: ReservedInstanceReporting,
    AWS_CLOUDFINANCIALMANAGEMENT_SAVINGPLANS: SavingsPlans,
    AWS_COMPUTE_EC2: EC2,
    AWS_COMPUTE_AUTOSCALING: AutoScaling,
    AWS_COMPUTE_M5N: M5n,
    AWS_COMPUTE_R5M: R5n,
    AWS_KUBENAMESPACE: ElasticContainerKubernetes,
    AWS_COMPUTE_ECR: ElasticContainerRegistry,
    AWS_COMPUTE_ECS: ElasticContainerService,
    AWS_COMPUTE_GENOMICS: Genomics,
    AWS_COMPUTE_LIGHTSAIL: Lightsail,
    AWS_COMPUTE_APPRUNNER: AppRunner,
    AWS_COMPUTE_BATCH: Batch,
    AWS_COMPUTE_OPTIMIZER: ComputeOptimizer,
    AWS_COMPUTE_ELASTIC_BEANSTALK: ElasticBeanstalk,
    AWS_COMPUTE_FARGATE: Fargate,
    AWS_COMPUTE_LOCALZONES: LocalZones,
    AWS_COMPUTE_NITRO_ENCLAVES: NitroEnclaves,
    AWS_COMPUTE_OUTPOSTS_FAMILY: OutpostsFamily,
    AWS_COMPUTE_OUTPOSTS_RACK: OutpostsRack,
    AWS_COMPUTE_OUTPOSTS_SERVERS: OutpostsServers,
    AWS_COMPUTE_PARALLEL_CLUSTER: ParallelCluster,
    AWS_COMPUTE_SAR: ServerlessApplicationRepository,
    AWS_COMPUTE_SIMSPACE_WEAVER: SimSpaceWeaver,
    AWS_COMPUTE_THINKBOX_DEADLINE: ThinkboxDeadline,
    AWS_COMPUTE_THINKBOX_FROST: ThinkboxFrost,
    AWS_COMPUTE_THINKBOX_KRAKATOA: ThinkboxKrakatoa,
    AWS_COMPUTE_THINKBOX_SEQUOIA: ThinkboxSequoia,
    AWS_COMPUTE_THINKBOX_STOKE: ThinkboxStoke,
    AWS_COMPUTE_THINKBOX_XMESH: ThinkboxXMesh,
    AWS_COMPUTE_WAVELENGTH: Wavelength,
    AWS_COMPUTE_BOTTLEROCKET: Bottlerocket,
    AWS_COMPUTE_EFA: ElasticFabricAdapter,
    AWS_COMPUTE_NICE_DCV: NICE_DCV,
    AWS_COMPUTE_NICE_ENGINFRAME: NICEEnginFrame,
    AWS_COMPUTE_VMWARECLOUD: VMWareCloudOnAWS,
    AWS_ELASTICACHE: awsElastiCache,
    AWS_NEPTUNE: awsNeptune,
    GCP_BIG_QUERY_TABLE: BigQuery,
    GCP_BIG_TABLE: BigTable,
    GCP_BUCKET: CloudStorage,
    GCP_CLOUD_FUNCTION: CloudFunctions,
    GCP_COMPUTE_INSTANCE: ComputeEngine,
    GCP_PROJECT: Project,
    GCP_PUBSUB_SUSCRIPTION: PubSub,
    GCP_PUBSUB_TOPIC: PubSub,
    GCP_GKE_CLUSTER: GKECluster,
    GCP_SQL_INSTANCE: SQLInstance,
    GCP_KUBENAMESPACE: Kubernetes,
    AZURE_PROVIDER_METADATA_TYPE: AzureProviderMetadataType,
    AZURE_SQL_SERVER_TYPE: AzureSQLServerType,
    AZURE_TENANT_TYPE: AzureTenantType,
    AZURE_SUBSCRIPTION_TYPE: AzureSubscriptionType,
    AZURE_RESOURCE_GROUP_TYPE: AzureResourceGroupType,
    AZURE_VM_TYPE: AzureVMType,
    AZURE_SQL_SERVER_DATABASE_TYPE: AzureSQLServerDatabaseType,
    AZURE_SQL_INSTANCE_POOL_TYPE: AzureSQLInstancePoolType,
    AZURE_ROLE_DEFINITION_TYPE: AzureRoleDefinitionType,
    AZURE_KUBENAMESPACE: AzureKubernetes,
    AWS_APPLICATION: AwsApplication,
    AZURE_APPLICATION: AzureApplication,
    DROPBOX_APPLICATION: DropboxApplication,
    GOOGLE_APPLICATION: GoogleApplication,
    NGINX_APPLICATION: NginxApplication,
    GENERIC_APPLICATION: GenericApplication,
    REST_API: ServiceIcons.REST_API,
    HTTPS_APPLICATION: HttpsApplication,
    SAML_APPLICATION: SamlApplication,
    // ADDED JAN 24, 2024
    OIDC: Oidc,
    OKTA: Okta,
    Entra: Entra,
    Auth0: Auth0,
    OneLogin: OneLogin,
    Ping: Ping,
    // ADDED AUG 8, 2023
    AWS_CHILD: awsChild,
    AWS_ORG: awsOrg,
    AZURE_RESOURCE_GROUP: AzureResourceGroup,
    AZURE_RESOURCE_GROUP_MONO: AzureResourceGroupMono,
    AZURE_SUSCRIPTIONS: AzureSuscription,
    AZURE_SERVER: AzureServer,
    GCP_GOOGLE_FOLDER: GcpGoogleFolder,
    GCP_ORG: GcpOrg,
    GCP_GOOGLE_PROJECT: GcpProject,
    GCP_GOOGLE_PROJECT_MONO: GcpProjectMono,
    GCP_GOOGLE_PROJECT_SOLID: GcpProjectSolid,
    GCP_DATABASE: GcpDatabase,
    GCP_ROLE: GcpRole,
    GITHUB_REPOSITORIES_MONO: GithubRepositoriesMono,
    // Service Icons
    TRUSTED_RELATIONS: TrustedRelations,
    // ADDED JAN 16, 2023
    SERVICENOW: ServiceNow,
    JIRA: Jira
};
